import { useCallback, useContext } from "react";
import { stateContext } from "./ctx";
import { icons } from "./icons"

const FavsShow = () => {
    const {setShowFavs,showFavs,session} = useContext(stateContext)

    const count = useCallback(()=>{
        let cnt = localStorage.getItem('MESHERSAVES')
        cnt = cnt ? JSON.parse(cnt) : {}
        cnt = Object.keys(cnt).length
        return <div className='absolute top-0 right-0 bg-accent text-[10px] text-white w-4 h-4 flex items-center justify-center rounded'>{cnt}</div>
    },[session])


    return <div onClick={()=>setShowFavs(!showFavs)} className='flex relative hover:bg-mute-100 cursor-pointer p-3 gap-3 rounded-xl hover:dark:bg-slate-800'>
        Favourites {icons.folder}{count()}</div>
}

export default FavsShow;